/* V2 catalog interactions: native buttons retain pointer and keyboard behavior. */
(() => {
  class PMFlipCard extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const button = this.querySelector('button');
      if (!button) return;
      const isBenefit = this.matches('.pm-meet-purifier__benefit') || !!this.closest('.pm-home-tabs__card');
      if (isBenefit) this.dataset.pmBenefitFlip = 'true';
      if (this.matches('.pm-meet-purifier__benefit')) {
        const back = this.querySelector('[data-flip-back]');
        const icon = this.querySelector('[data-flip-front] img');
        if (back && icon && !back.querySelector('.pm-benefit-back-icon')) {
          const text = document.createElement('span');
          text.textContent = back.textContent;
          const backIcon = icon.cloneNode(true);
          backIcon.className = 'pm-benefit-back-icon';
          backIcon.setAttribute('aria-hidden', 'true');
          back.replaceChildren(backIcon, text);
        }
      }
      const set = (open, animate = false) => {
        const isNotice = this.classList.contains('pm-v2-demand');
        const fromHeight = isNotice ? this.getBoundingClientRect().height : 0;
        this.noticeAnimation?.cancel();
        this.noticeAnimation = null;
        if (isNotice) this.style.overflow = '';
        button.setAttribute('aria-expanded', String(open));
        this.dataset.flipped = String(open);
        this.querySelector('[data-flip-front]').hidden = open;
        this.querySelector('[data-flip-back]').hidden = !open;
        if (isBenefit) {
          this.querySelector('[data-flip-front]').setAttribute('aria-hidden', String(open));
          this.querySelector('[data-flip-back]').setAttribute('aria-hidden', String(!open));
        }
        if (isNotice && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const toHeight = this.getBoundingClientRect().height;
          this.style.overflow = 'hidden';
          const animation = this.animate([
            { height: `${fromHeight}px` }, { height: `${toHeight}px` }
          ], { duration: 280, easing: 'ease-in-out' });
          this.noticeAnimation = animation;
          animation.onfinish = () => {
            if (this.noticeAnimation !== animation) return;
            this.noticeAnimation = null;
            this.style.overflow = '';
          };
        }
      };
      set(false);
      button.addEventListener('click', () => set(this.dataset.flipped !== 'true', true), { signal: this.abort.signal });
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.dataset.flipped === 'true') {
          event.preventDefault();
          set(false, true);
        }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.noticeAnimation?.cancel(); }
  }
  if (!customElements.get('pm-flip-card')) customElements.define('pm-flip-card', PMFlipCard);

  // A tall column scrolls into view before its bottom catches the viewport.
  // Native sticky positioning then releases at its own section's boundary.
  const stickyTargets = new Set();
  const resize = new ResizeObserver((entries) => entries.forEach(({ target }) => measure(target)));
  function measure(target) {
    target.style.setProperty('--pm-sticky-top', `${Math.min(16, innerHeight - 16 - target.offsetHeight)}px`);
  }
  function register(root = document) {
    root.querySelectorAll('[data-pm-sticky-column]').forEach((target) => {
      if (stickyTargets.has(target)) return;
      stickyTargets.add(target);
      resize.observe(target);
      measure(target);
    });
  }
  register();
  window.addEventListener('resize', () => stickyTargets.forEach(measure), { passive: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', () => {
    stickyTargets.forEach((target) => {
      if (!target.isConnected) { resize.unobserve(target); stickyTargets.delete(target); }
    });
  });
})();
